// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.cdnfonts.com/css/avenir);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow+Condensed:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes pulse {
  0%, 100% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
}
/* Basic resets */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: Avenir, "avenir", sans-serif;
}

.chat-component {
  position: fixed;
  z-index: 8;
}

.chat-wrapper {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
}

.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
  opacity: 0;
  animation: fadeIn 0.3s ease forwards;
}

.chat-window {
  width: 586px;
  height: 630px;
  display: flex;
  flex-direction: column;
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  background-color: #fff;
}
.chat-window .wmde-markdown {
  color: #001E45 !important;
  font-size: 1rem !important;
}

@media (max-width: 600px) {
  /* Full screen chat window */
  .chat-window {
    width: 100vw;
    height: 100vh;
    border-radius: 0;
    box-shadow: none;
    /* Adjust header for mobile */
  }
  .chat-window .chat-header {
    padding: 10px 15px;
  }
  .chat-window .chat-header .logo-text {
    font-size: 14px;
    gap: 10px;
  }
  .chat-window .chat-header .logo-text img {
    height: 35px !important;
  }
  .chat-window {
    /* Make messages more compact on mobile */
  }
  .chat-window .messages-container {
    padding: 20px 20px 60px;
    min-height: calc(100vh - 157px - 40px - env(safe-area-inset-bottom, 0));
    max-height: calc(100vh - 157px - 40px - env(safe-area-inset-bottom, 0));
  }
  .chat-window .messages-container .message {
    max-width: 85%;
    font-size: 13px;
  }
  .chat-window {
    /* Improve input area for mobile */
  }
  .chat-window .message-input-form {
    padding: 10px;
  }
  .chat-window .message-input-form .message-input {
    padding: 10px 12px;
    font-size: 16px;
  }
  /* Make sure the chat component takes full screen */
  .chat-component {
    position: fixed !important;
  }
  /* Fix the wrapper positioning */
  .chat-wrapper {
    width: 100%;
    height: 100%;
    transform: none;
    top: 0;
    left: 0;
    z-index: 99999;
  }
  .backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(2px);
    opacity: 0;
    animation: fadeIn 0.3s ease forwards;
  }
}
/* Additional fixes for very small screens */
@media (max-width: 360px) {
  .chat-window .chat-header .logo-text p {
    font-size: 12px;
  }
  .chat-window .chat-header .logo-text img {
    height: 30px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/animation.scss","webpack://./src/styles/styles.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AACA;EACI;IACI,YAAA;ECEN;EDAE;IACI,UAAA;ECEN;AACF;AAJA,iBAAA;AACA;EACE,sBAAA;EACA,SAAA;EACA,UAAA;EACA,yCCPY;ADad;;AAHA;EACE,eAAA;EAGA,UAAA;AAIF;;AACA;EACI,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WCLU;ADOd;;AACA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EAEA,0BAAA;EACA,UAAA;EACA,oCAAA;AAEJ;;AACA;EACI,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBChCY;EDiCZ,gBAAA;EACA,yCCpCS;EDqCT,sBCxCe;AD0CnB;AAAI;EACI,yBAAA;EACA,0BAAA;AAER;;AAEA;EACI,4BAAA;EACA;IACI,YAAA;IACA,aAAA;IACA,gBAAA;IACA,gBAAA;IAEA,6BAAA;EAAN;EACM;IACI,kBAAA;EACV;EACU;IACI,eAAA;IACA,SAAA;EACd;EACc;IACI,uBAAA;EAClB;EAhBE;IAoBI,yCAAA;EADN;EAEM;IACI,uBAAA;IACA,uEAAA;IACA,uEAAA;EAAV;EAEU;IACI,cAAA;IAEA,eAAA;EADd;EA5BE;IAiCI,kCAAA;EAFN;EAGM;IACI,aAAA;EADV;EAGU;IACI,kBAAA;IACA,eAAA;EADd;EAME,mDAAA;EACA;IACI,0BAAA;EAJN;EAWE,gCAAA;EACA;IACI,WAAA;IACA,YAAA;IACA,eAAA;IACA,MAAA;IACA,OAAA;IACA,cAAA;EATN;EAaE;IACI,eAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;IACA,YAAA;IACA,8BAAA;IAEA,0BAAA;IACA,UAAA;IACA,oCAAA;EAXN;AACF;AAeA,4CAAA;AACA;EAEQ;IACI,eAAA;EAdV;EAiBM;IACI,uBAAA;EAfV;AACF","sourcesContent":["// _animations.scss - Animation keyframes\n@keyframes pulse {\n    0%, 100% {\n        opacity: 0.4;\n    }\n    50% {\n        opacity: 1;\n    }\n}\n","// main.scss - Main file to import all component styles\n// This would be your main entry point for styles\n@use \"variables\" as *;\n@use \"animation\" as *;\n\n/* Basic resets */\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  font-family: $font_family;\n}\n\n.chat-component {\n  position: fixed;\n  //bottom: 0;\n  //right: 0;\n  z-index: 8;\n  //width: 100%;\n  //height: 100vh;\n}\n\n.chat-wrapper {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    z-index: $zindex_chat;\n}\n\n.backdrop {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5);\n    -webkit-backdrop-filter: blur(2px);\n    backdrop-filter: blur(2px);\n    opacity: 0;\n    animation: fadeIn 0.3s ease forwards;\n}\n\n.chat-window {\n    width: 586px;\n    height: 630px;\n    display: flex;\n    flex-direction: column;\n    border-radius: $border_radius;\n    overflow: hidden;\n    box-shadow: $box_shadow;\n    background-color: $background_light;\n\n    .wmde-markdown {\n        color: #001E45 !important;\n        font-size: 1rem !important;\n    }\n}\n\n@media (max-width: $mobile_breakpoint) {\n    /* Full screen chat window */\n    .chat-window {\n        width: 100vw;\n        height: 100vh;\n        border-radius: 0;\n        box-shadow: none;\n\n        /* Adjust header for mobile */\n        .chat-header {\n            padding: 10px 15px;\n\n            .logo-text {\n                font-size: 14px;\n                gap: 10px;\n\n                img {\n                    height: 35px !important;\n                }\n            }\n        }\n\n        /* Make messages more compact on mobile */\n        .messages-container {\n            padding: 20px 20px 60px;\n            min-height: calc(100vh - 157px - 40px - env(safe-area-inset-bottom, 0));\n            max-height: calc(100vh - 157px - 40px - env(safe-area-inset-bottom, 0));\n\n            .message {\n                max-width: 85%;\n                //padding: 12px 16px;\n                font-size: 13px;\n            }\n        }\n\n        /* Improve input area for mobile */\n        .message-input-form {\n            padding: 10px;\n\n            .message-input {\n                padding: 10px 12px;\n                font-size: 16px;\n            }\n        }\n    }\n\n    /* Make sure the chat component takes full screen */\n    .chat-component {\n        position: fixed !important;\n        //top: 0;\n        //left: 0;\n        //width: 100vw;\n        //height: 100vh;\n    }\n\n    /* Fix the wrapper positioning */\n    .chat-wrapper {\n        width: 100%;\n        height: 100%;\n        transform: none;\n        top: 0;\n        left: 0;\n        z-index: 99999;\n    }\n\n\n    .backdrop {\n        position: fixed;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        background: rgba(0, 0, 0, 0.5);\n        -webkit-backdrop-filter: blur(2px);\n        backdrop-filter: blur(2px);\n        opacity: 0;\n        animation: fadeIn 0.3s ease forwards;\n    }\n\n}\n\n/* Additional fixes for very small screens */\n@media (max-width: $small_screen_breakpoint) {\n    .chat-window .chat-header .logo-text {\n        p {\n            font-size: 12px;\n        }\n\n        img {\n            height: 30px !important;\n        }\n    }\n}\n\n","@import url(\"https://fonts.cdnfonts.com/css/avenir\");\n@import url(\"https://fonts.googleapis.com/css2?family=Barlow+Condensed:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\n$font_family: Avenir, \"avenir\", sans-serif;\n$font_family_button: \"Barlow Condensed\", sans-serif;\n$primary_color: #0066cc;\n$primary_hover_color: #00336a;\n$secondary_color: #00868b;\n$text_color: #414141;\n$text_light_color: white;\n$border_color: #e0e0e0;\n$background_light: #fff;\n$background_medium: #f5f5f5;\n$background_dark: rgb(7, 30, 47);\n$box_shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n$box_shadow_light: 0 1px 2px rgba(0, 0, 0, 0.1);\n$border_radius: 15px;\n$border_radius_small: 4px;\n$border_radius_large: 12px;\n$border_radius_round: 24px;\n$border_radius_circle: 50%;\n$transition_time: 0.2s;\n$zindex_chat: 10;\n$zindex_chat_button: 1001;\n\n// Breakpoints\n$mobile_breakpoint: 600px;\n$small_screen_breakpoint: 360px;\n\n// Mixins\n@mixin flex_center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@mixin flex_between {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n@mixin flex_start {\n  display: flex;\n  align-items: center;\n}\n\n@mixin transition($property: all) {\n  transition: $property $transition_time;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
